import React from 'react'
import { StructureCell, StructureHeaderCell, StructureRow, StructureTable } from './style'
import { StructureDataObject } from '../../../../contexts/CertificatesContext'

interface propsType{
  structure:StructureDataObject
}

const ViewStructuresTable:React.FC<propsType> = (props) => {  
  const { structure } = props
  
  return(
    <StructureTable>
      <thead>
        <StructureRow className='header'>
          <StructureHeaderCell></StructureHeaderCell>
          {structure.tableColumns.map((item,index) => (
            <StructureHeaderCell key={index}>{item}</StructureHeaderCell>
          ))}
        </StructureRow>
      </thead>
      <tbody>
          {structure.tableRows.map((item, index) => (
            <StructureRow key={index} className={index === structure.tableRows.length -1 ? 'last' : ''}>
              <StructureCell className='rowName'>{item}</StructureCell>
              {structure.tableData[index].map((item, index) => (
                <StructureCell key={index}>{item}</StructureCell>
              ))}
            </StructureRow>
          ))}
      </tbody>
    </StructureTable>
  )
}

export default ViewStructuresTable